// @flow

import * as React from 'react';

import { type PreviewVenue } from './types';
import { formatPrice } from 'utils/currencyUtils';

import styles from './VenuePreviewPrice.scss';

type Props = {|
  venue: PreviewVenue
|};

export default function VenuePreviewPrice(props: Props): React.Node {
  const pricingPreview = pickVenuePricingPreview(props.venue);

  return pricingPreview ? (
    <div className={styles.venuePriceOverlay}>
      <div className={styles.venuePrice}>
        {`${__('venues.similar_venues.starting_from_prefix')} `}
        {pricingPreview.formattedPrice}
      </div>
      <div className={styles.venuePriceDetails}>{pricingPreview.legend}</div>
    </div>
  ) : null;
}

type PricingPreviewOption = {|
  price: number,
  formattedPrice: string,
  legend: string
|};

function venuePricingPreviewOptions(
  venue: PreviewVenue,
  formatPriceWithLocale: number => string
): Array<PricingPreviewOption> {
  return [
    {
      price: venue.rent_per_day || 0,
      formattedPrice: formatPriceWithLocale(venue.rent_per_day || 0),
      legend: __('venues.similar_venues.rent_per_day')
    },
    {
      price: venue.rent_per_hour || 0,
      formattedPrice: formatPriceWithLocale(venue.rent_per_hour || 0),
      legend: __('venues.similar_venues.rent_per_hour.hour')
    },
    {
      price: venue.rent_per_person || 0,
      formattedPrice: formatPriceWithLocale(venue.rent_per_person || 0),
      legend: __('venues.similar_venues.rent_per_person.person')
    },
    {
      price: venue.sales_guarantee || 0,
      formattedPrice: formatPriceWithLocale(venue.sales_guarantee || 0),
      legend: __('venues.similar_venues.sales_guarantee')
    }
  ];
}

function pickVenuePricingPreview(venue: PreviewVenue): ?PricingPreviewOption {
  const pricingPreviewsOptions = venuePricingPreviewOptions(venue, price =>
    formatPrice(price, { precision: 0, locale: venue.locale })
  );

  const firstApplicablePricingPreview = pricingPreviewsOptions.find(
    p => p.price > 0
  );

  return firstApplicablePricingPreview;
}
